<template>
  <div class="offcanvas offcanvas-end  bg-light" tabindex="-1" :id="offcanvas_id" data-bs-backdrop="static" :aria-labelledby="`${offcanvas_id}_label`">
    <!-- <div class="offcanvas-header">
      <button class="btn-back" type="button" name="button" data-test="btnCloseOffcanvas" data-bs-dismiss="offcanvas" aria-label="Close">
        <IconArrowBack/>
        {{ $t('goBack') }}
      </button>
      <h5 class="offcanvas-title d-block" :id="`${offcanvas_id}_label`">{{ title }}</h5>
    </div> -->
    <div class="offcanvas-body">
      <div class="text-center">
        <h1>{{ $t('createDevice.title') }}</h1>
        <div id="qrCodeDiv" @dblclick="copyQRCode()"></div>
        <p>{{ $t('createDevice.info') }}</p>
      </div>
    </div>
    <div class="offcanvas-footer">
      <button type="button" class="btn" :class="okButtonClass" data-bs-dismiss="offcanvas" v-if="okButton" data-test="btnConfirm" @click="doConfirm">{{ okButton }}</button>
      <button type="button" class="btn" :class="cancelButtonClass" data-bs-dismiss="offcanvas" v-if="cancelButton" data-test="btnCancel" @click="doCancel">{{ cancelButton }}</button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.offcanvas {
  .offcanvas-body {
    display:                            flex;
    flex-direction:                     column;
    justify-content:                    center;
    align-items:                        center;
    gap:                                19px;
    padding:                            40px 40px 0;

    h1 {
      font-size:                        26px;
      max-width:                        311px;
      margin:                           0 auto;
      color:                            black !important;
    }

    p {
      font-size:                        var(--font-size-14);
      color:                           black !important;
    }

    h1,
    p {
      color:                            var(--Brand-Primary);
      font-weight:                      300;
      line-height:                      140%; /* 19.6px */
      margin-bottom:                    0;
    }

    #qrCodeDiv {
      margin:                           10px;
    }
  }

  .offcanvas-footer {
    padding:                            20px 40px;
    border-top:                         1px solid var(--Shades-30);

    .btn {
      font-size:                        var(--font-size-14);
      font-weight:                      700;
      line-height:                      normal;
      letter-spacing:                   4.2px;
      text-align:                       center;
      text-transform:                   uppercase;
      margin:                           0 auto;
      padding:                          20px;
    }

    .btn-success {
      color:                            var(--Shades-W, #FFF);
    }
  }
}
</style>

<script>
import { Offcanvas } from 'bootstrap';
import kjua from 'kjua'
import { nextTick } from 'process';


export default {
  name: 'BaseGenericOffcanvas',
  props: ['offcanvas_id'],
  data: () => ({
    title: null,
    text: null,
    okButton: null,
    okButtonClass: null,
    cancelButton: null,
    cancelButtonClass: null,
    offcanvas_device: null,
    bsOffcanvasInstance: null,
    resolvePromise: null,
    rejectPromise: null,
    qrCode: null,
  }),
  mounted() {
    const offcanvasElement = document.getElementById(this.offcanvas_id);

    if(offcanvasElement){
      //initializar the bootstrap offcanvas instance only once
      this.bsOffcanvasInstance = new Offcanvas(offcanvasElement);

      offcanvasElement.addEventListener('shown.bs.offcanvas', this.onOffcanvasShown);
      offcanvasElement.addEventListener('hidden.bs.offcanvas', this.onOffcanvasHidden);
    }
  },
  beforeUnmount() {
    const offcanvasElement = document.getElementById(this.offcanvas_id);
    if (offcanvasElement) {
      offcanvasElement.removeEventListener('shown.bs.offcanvas', this.onOffcanvasShown);
      offcanvasElement.removeEventListener('hidden.bs.offcanvas', this.onOffcanvasHidden);
    }
    if (this.bsOffcanvasInstance) {
      //call used to destroy a Bootstrap Offcanvas instance.
      this.bsOffcanvasInstance.dispose();
      this.bsOffcanvasInstance = null;
    }
  },
  methods: {
    show(options = {}) {
      this.resetState();

      if (options.title)
        this.title = options.title

      if (options.text)
        this.text = options.text

      if (options.okButton) {
        this.okButton = options.okButton
        this.okButtonClass = options.okButtonClass
      }

      if (options.cancelButton) {
        this.cancelButton = options.cancelButton
        this.cancelButtonClass = options.cancelButtonClass
      }
      
      if(this.bsOffcanvasInstance){
        this.bsOffcanvasInstance.show()
        nextTick(() => {
            this.fetchData()
          })
        
      }else {
        console.error('Bootstrap Offcanvas instance not found. Make sure it is initialized in mounted().');
        return Promise.reject('Offcanvas not initialized.');
      }
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },
    resetState(){

      this.title = null,
      this.text = null,
      this.okButton = null,
      this.okButtonClass = null,
      this.cancelButton = null,
      this.cancelButtonClass = null,

      this.rejectPromise = null,
      this.rejectPromise = null

    },

    doConfirm() {
      const qrCodeDiv = document.getElementById('qrCodeDiv');
      if (qrCodeDiv) {
        qrCodeDiv.innerHTML = '';
      }
      
      this.offcanvas_device = null;
      this.qrCode = null;
      
      // Fecha o modal explicitamente
      if (this.bsOffcanvasInstance) {
        this.bsOffcanvasInstance.hide();
      }
      
      this.offcanvas_device = null;
      this.resolvePromise(true)
    },

    doCancel() {
      const qrCodeDiv = document.getElementById('qrCodeDiv');
      
      if (qrCodeDiv) {
        qrCodeDiv.innerHTML = '';
      }
      this.qrCode = null;
      this.offcanvas_device = null;
      this.resolvePromise(false);
    },

    async fetchData() {
      this.loading = true
      NProgress.start()
      try {
        let response = await this.$deviceService.registerDevice()

        this.initializeWebsocket(response.qrcode);
        this.bindQRCode(response.qrcode);
      } catch (err) {
        console.log(err)
        this.$message.popup(this, 'request_error', 'operationFail', 'error')
        // this.alert = this.$message.alert(this, 'request_error', 'danger')
      }
      NProgress.done(true)
      this.loading = false
    },

    initializeWebsocket(data) {
      const io = this.$io
      console.log("webSocketInitialization() isConnected?", io.socket.isConnected())

      for (let e of ['registrationStarted', 'deviceRegistration']) {
        console.log('[new-device] unlisten to ws event:', e)
        io.socket.off(e);
      }

      if (io.socket.isConnected()) {
        console.log("io socket connection active, listening now!")
        this.listenToWebsocketEvents(data)
        return
      }

      io.socket.on('connect', () => {
        this.listenToWebsocketEvents(data);
      });

      io.socket.on('disconnect', () => {
        console.log("DICONNECT")
      });

      this.listenToWebsocketEvents(data)
    },
    listenToWebsocketEvents(data) {
      let _self = this
      const io = this.$io

      io.socket.get('/online/deviceRegistration?id=' + data.sessionKey, function gotResponse(body, response) {
        console.log('device registration response > ', response);
        console.log('device registration body > ', body);
      });

      io.socket.on('registrationStarted', function(data) {
        console.log("Registration started: " + JSON.stringify(data));
  		});

      io.socket.on('deviceRegistration', data => {
        console.log("deviceRegistration data:", data);

        if (data.error) {
          _self.$message.popup(_self, 'operationFail', 'operationFail', 'error')
          // this.alert = this.$message.alert(this, 'operationFail', 'danger')
        } else {
          _self.$message.popup(_self, 'general.updatedSuccess', 'operationSuccess', 'success')
          nextTick(() => {
            _self.doConfirm()
          })
          
          // this.$router.push({name: 'device-list', query: { ...this.$route.query, t: Date.now() }})
        }
  		});
    },
    
    bindQRCode(data) {
      this.qrCode = JSON.stringify(data)
      let options = {
        render: 'canvas', // render method: 'canvas', 'image' or 'div'
        crisp: true,
        // version range somewhere in 1 .. 40
        minVersion: 1,
        maxVersion: 40,
        // error correction level: 'L', 'M', 'Q' or 'H'
        ecLevel: 'L',
        // size in pixel
        size: 200,
        // pixel-ratio, null for devicePixelRatio
        ratio: null,
        // code color or image element
        fill: '#000',
        // background color or image element, null for transparent background
        background: null,
        // content
        text: this.qrCode,
        rounded: 0,
        // quiet zone in modules
        quiet: 0,

        mode: "label",

        mSize: 15,
        mPosX: 50,
        mPosY: 50,

        label: 'Eyer',
        fontname: 'sans',
        fontcolor: '#60bda2'
      }

      const qrCodeDiv = document.getElementById('qrCodeDiv');
      qrCodeDiv.innerHTML = '';
      const qrCodeElement = kjua(options);
      qrCodeDiv.appendChild(qrCodeElement);
    },
    copyQRCode() {
      navigator.clipboard.writeText(this.qrCode);
    }
  }
}
</script>